module.exports = __webpack_public_path__ + "img/a_land.571c43a6.png";